import styled from 'styled-components';
import {COLORS} from 'shared/consts';

export const Card = styled.div`
  padding: 18px 16px;
  border-radius: 16px;
  background: ${COLORS.BG.ELEVATED.M};
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 88px;
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.FG.DEFAULT};
`;

export const Time = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${COLORS.FG.MUTED};
`;

export const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 16px;
  width: fit-content;
`;

export const StatusDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
`;

export const StatusText = styled.div`
  font-size: 12px;
  font-weight: 500;
`;
